module.exports = __webpack_public_path__ + "static/media/Real-World.b1c5fcdd.png";